"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
// TODO: add async based on script from Sitecore param later
var addScript = url => {
  if (typeof document !== 'undefined') {
    (0, _react.useEffect)(() => {
      var script = document.createElement('script');
      script.src = url;
      script.type = 'text/javascript';
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }, [url]);
  }
};
var _default = exports.default = addScript;